<script>

var aqty = null;
var info = {
  "www.sampsonstore.com":{
    "locale":[
      "enus","zhhk"
    ]
  },
  "staging.sampsonstore.com":{
    "context":"/nv",
    "locale":[
      "enus","zhhk"
    ]
  },
  "staging.tw.sampsonstore.com":{
    "context":"/nv",
    "curr":"TWD",
    "locale":[
      "enus","zhtw"
    ]
  },
  "stagingau.sampsonstore.com":{
    "context":"/nv",
    "curr":"AUD",
    "locale":[
      "enau"
    ]
  },
  "au.sampsonstore.com":{
    "context":"/nv",
    "curr":"AUD",
    "locale":[
      "enau"
    ]
  },
  "tw.sampsonstore.com":{
    "context":"/nv",
    "curr":"TWD",
    "locale":[
      "enus","zhtw"
    ]
  },
  "staging.uk.sampsonstore.com":{
    "context":"/nv",
    "curr":"GBP",
    "locale":[
      "engb"
    ]
  },
  "uk.sampsonstore.com":{
    "context":"/nv",
    "curr":"GBP",
    "locale":[
      "engb"
    ]
  },
  "staging.sg.sampsonstore.com":{
    "context":"/nv",
    "curr":"SGD",
    "locale":[
      "enus"
    ]
  },
  "sg.sampsonstore.com":{
    "context":"/nv",
    "curr":"SGD",
    "locale":[
      "enus"
    ]
  }
};
var context = '/neovision';
var ctpath = '/b2b';
var pRoot = '/b2b';
var curr = 'HKD';
var hostname = window.location.href.substring(window.location.href.indexOf('//')+2);
hostname = hostname.substring(0, hostname.indexOf('/'));
var sinfo = info[hostname];
if (sinfo != null) {
  if (sinfo['context']) {
    context = sinfo['context'];
  }
  if (sinfo['curr']) {
    curr = sinfo['curr'];
  }
}

var num_display_format_basic = "###,###,###,###.";
var num_display_format = "###,###,###,###.0";
var num_cal_format = "0.0";
import Vue from 'vue'
import VueResource from 'vue-resource'
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(VueResource);

var loc = window.location.href.substring(window.location.href.indexOf('/', 10));
loc = loc.substring(0, loc.indexOf('/', 1));
pRoot = loc;
Vue.http.interceptors.push(function(request) {
  return function(response) {
    if (response.status == 403) {
      window.location.href = pRoot + '/reglogin.html';
    }
  };
});

Vue.filter('fullDate', function (date, fullmonth, str) {
  var out = str;
  out = out.replace(new RegExp('{fullyear}', 'g'), date.getFullYear());
  out = out.replace(new RegExp('{year}', 'g'), date.getYear());
  out = out.replace(new RegExp('{fullmonth}', 'g'), fullmonth);
  out = out.replace(new RegExp('{month}', 'g'), (date.getMonth()+1));
  out = out.replace(new RegExp('{pmonth}', 'g'), String(date.getMonth()+1).padStart(2, '0'));
  out = out.replace(new RegExp('{date}', 'g'), date.getDate());
  out = out.replace(new RegExp('{pdate}', 'g'), String(date.getDate()).padStart(2, '0'));
  return out;
});

Vue.filter('trimDate', function (date) {
  var idx = date.indexOf(" ");
  if (idx > 0) {
    return date.substring(0, idx);
  }
  return date;
});

Vue.filter('printLine', function (line, values) {
  if (line == null) return null;
  var out = line;
  Object.keys(values).forEach(function(key) {
    var val = values[key];
    if (val != null) {
      out = out.replace(new RegExp('{'+key+'}', 'g'), val);
    }
  });
  return out;
});

Vue.filter('format', function (value, fmt, txt) {
  //console.log('format:', value, fmt, txt);
  var val = null;
  if (fmt == null || fmt == '') {
    val = numeral(value).format(num_display_format);
  } else if (isNaN(fmt)) {
    val = numeral(value).format(fmt);
  } else {
    var tmp = num_display_format_basic;
    for (var i=0;i<fmt;i++) {
      tmp = tmp + '0';
    }
    val = numeral(value).format(tmp);
  }
  if (txt != null) {
    //console.log('format:', value, fmt, txt);
    return txt.replace('${val}', val);
  }
  return val;
});

var qs = (function(a) {
    var b = {};
    b["locale"] = Vue.cookie.get('locale');
    if (a == "") {
      if (sinfo != null && sinfo['locale'] != null) {
        if (sinfo['locale'].indexOf(b["locale"]) < 0) {
          b["locale"] = sinfo['locale'][0];
          Vue.cookie.set('locale', b["locale"]);
        }
      }
      if (b["locale"] == null) {
        //b["locale"] = 'zhhk';
        //Vue.cookie.set('locale', 'zhhk');
      }
      return b;
    }
    for (var i = 0; i < a.length; ++i)
    {
        var p=a[i].split('=', 2);
        if (p.length == 1) {
            b["pinfo"] = p[0];
            b[p[0]] = "";
        } else {
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
    }

    var locale = b["locale"];
    if (sinfo != null && sinfo['locale'] != null) {
      if (sinfo['locale'].indexOf(locale) < 0) {
        locale = sinfo['locale'][0];
        b["locale"] = locale;
      }
    }
    if (locale != null) {
      Vue.cookie.set('locale', locale);
    } else {
      b["locale"] = Vue.cookie.get('locale');
    }
    if (b["locale"] == null) {
      //b["locale"] = 'zhhk';
      //Vue.cookie.set('locale', 'zhhk');
    }
    var affcode = b["affcode"];
    var u = '';
    if (affcode != null) {
      u = u + "&affcode="+affcode;
      if (document.referrer != null && document.referrer != '') {
        u = u + "&referrer="+document.referrer;
      } else if (b["referrer"] != null) {
        u = u + "&referrer="+b["referrer"];
      }
      b["affcode_url"] = u;
    }

    return b;
})(window.location.search.substr(1).split('&'));

//console.log(qs);
export default {
  data () {
    return {
      config:null,
      dp:1,
      querystring:qs,
      packed_status:['3', '6', '7', '8', '11', '12', '19'],
      delivered_status:['8', '12', '15'],
      cancel_status:['2'],
      paid_status:['2', '4'],
      readytopay_status:['7'],
      delivery_options:['SF', 'GO', 'SH'],
      payment_options:['BI', 'CC', 'CH', 'QR'],
      locale:qs["locale"]
    }
  },
  EventBus: new Vue(),
  isPaymentOptions :function(itype) {
    return this.data().payment_options.indexOf(itype) >= 0;
  },
  isDeliveryOptions:function(itype) {
    return this.data().delivery_options.indexOf(itype) >= 0;
  },
  roundDecimal:function (val, precision) {
    // donno why sometimes toFixed will round down, eg 188.35 => 188.3, so need another function to do rounding @20220512
    return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
  },
  download:function(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },
  getHostname:function() {
    return hostname;
  },
  getDPNumber:function(num) {
    return num.toFixed(this.data().dp);
  },
  setConfig:function(config) {
    if (config.dp != null) {
      num_display_format = num_display_format.substring(0, num_display_format.lastIndexOf('.')+1);
      for (var i=0;i<config.dp;i++) {
        num_display_format = num_display_format + "0";
      }
      num_cal_format = num_cal_format.substring(0, num_cal_format.lastIndexOf('.')+1);
      for (var i=0;i<config.dp;i++) {
        num_cal_format = num_cal_format + "0";
      }
      this.data().dp = parseInt(config.dp);
    }
    if (config.currency != null) {
      curr = config.currency;
    }
    this.data().config = config;
  },
  getParam:function(name) {
    return this.data().querystring[name];
  },
  getDeliveredStatus:function() {
    return this.data().delivered_status;
  },
  getPackedStatus:function() {
    return this.data().packed_status;
  },
  getReadyToPayStatus:function() {
    return this.data().readytopay_status;
  },
  getPaidStatus:function() {
    return this.data().paid_status;
  },
  saveStorageStr:function(name, str) {
    var k = Vue.cookie.get('custcode');
    localStorage['sampsonstore.b2b.'+k+"."+name] = str;
  },
  delStorage:function(name) {
    var k = Vue.cookie.get('custcode');
    localStorage.removeItem('sampsonstore.b2b.'+k+"."+name);
  },
  saveStorage:function(name, jsono) {
    var k = Vue.cookie.get('custcode');
    var str = JSON.stringify(jsono);
    localStorage['sampsonstore.b2b.'+k+"."+name] = str;
  },
  getStorageStr:function(name) {
    var k = Vue.cookie.get('custcode');
    var str = localStorage['sampsonstore.b2b.'+k+"."+name];
    return str;
  },
  getStorage:function(name) {
    var str = this.getStorageStr(name);
    if (str != null && str != '') {
      return JSON.parse(str);
    }
    return null;
  },
  getCurrencySym() {
    return curr;
  },
  getNumCalFormat() {
    return num_cal_format;
  },
  getNumDisplayFormat() {
    return num_display_format;
  },
  isDebug:function() {
    return true && window.location.href.indexOf('staging') > 0;
  },
  getAQty:function(product_id) {
    if (aqty == null) {
      var aq = this.getStorageStr('cart.aqty');
      if (aq == null) return 0;
      aqty = JSON.parse(aq);
    }
    var q = aqty[product_id];
    if (q == null) return 0;
    return q;
  },
  cleanCart:function() {
    this.delStorage('cart.backup');
    this.delStorage('cart');
    this.delStorage('shippingid');
    this.delStorage('shippingid.backup');
  },
  restoreCart:function() {
    var str = this.getStorageStr('cart.backup');
    if (str != null) {
      this.saveStorageStr('cart', str);
      this.delStorage('cart.backup');
    } else {
    }
    // always remove the invoice from the storage
    this.delStorage('cart.aqty');
    this.delStorage('cart.invoiceid');
    var shipid = this.getStorageStr('shippingid.backup');
    if (shipid != null) {
      this.saveStorageStr('shippingid', shipid);
      this.delStorage('shippingid.backup');
    } else {
    }
  },
  backupCart:function(invoice) {
    var blk = this.getStorageStr('cart.backup');
    if (invoice != null) {
      this.saveStorageStr('cart.invoiceid', invoice.bill_no);
      if (blk != null && invoice.bckfk != null) {
        this.saveStorageStr('shippingid', invoice.bchfk);
        return;
      }
    }
    var str = this.getStorageStr('cart');
    //if (str != null && str.length > 2) {
    if (str != null) {
      this.saveStorageStr('cart.backup', str);
    }
    var shipid = this.getStorageStr('shippingid');
    if (shipid != null) {
      this.saveStorageStr('shippingid.backup', shipid);
      if (invoice != null) {
        this.saveStorage('shippingid', invoice.bchfk);
      }
    }
  },
  getCartStorage:function() {
    var str = this.getStorageStr('cart');
    if (str != null) {
      var c = JSON.parse(str);
/*
      for (var i=0;i<c.length;i++) {
         var pid = c[i].product_id;
         aqty = this.getAQty(pid);
console.log('aqty', aqty, pid);
         if (aqty > 0) {
           c[i].cqty = aqty;
         }
      }
console.log('cart storage', c);
*/
      return c;
    }
    return [];
  },
  subVals:function(line, vals) {
    for (var i=0;i<vals.length;i++) {
      var p = "\\$\\{"+i+"\\}";
      var re = new RegExp(p, "g");
      line = line.replace(re, vals[i]);
    }
    return line;
  },
  setCartStorage:function(cart) {
    if (cart == null) return;
    this.saveStorage('cart', cart);
  },
  getLocale:function() {
    return this.data().locale;
  },
  getQueryString:function() {
    return this.data().querystring;
  },
  getPageRoot: function() {
    return pRoot;
  },
  getServerContext: function() {
    return context;
  },
  getServerPath: function() {
    return context+ctpath;
    //return '/neovision/b2b';
  },
  saveJSONToForm:function(data) {
    var formdata = new FormData();
    Object.keys(data).forEach(function(key) {
//console.log(key, data[key]);
      formdata.append(key, data[key]);
    });
    return formdata;
  },
  saveData:function(data, func) {
    if (data.url != null) {
      if (data.url.indexOf('locale') < 0) {
        if (data.url.indexOf('?') < 0) {
          data.url = data.url + '?locale='+this.data().locale;
        } else {
          data.url = data.url + '&locale='+this.data().locale;
        }
      }
      Vue.http.post(data.url, data.value, {
        headers: {
         'Content-Type': 'multipart/form-data'
        }
      }).then(
        response => {
          func(true, response.body);
        },
        response => {
          func(false, response.body);
        }
      );
    } else {
      func();
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Utils.vue